import React from "react";
import * as Styled from "./styled";
import { BrowserView, MobileView } from "react-device-detect";
import close from "./assets/ic-close.svg";

function Modal(props) {
  return (
    <>
      <BrowserView>
        <Styled.Container>
          <Styled.InternalContainer>
            {props.onClose && <Styled.Close src={close} onClick={props.onClose} />}
            {props.children}
          </Styled.InternalContainer>
        </Styled.Container>
      </BrowserView>
      <MobileView>
        <Styled.InternalMobileContainer>
          {props.onClose && <Styled.MobileClose src={close} onClick={props.onClose} />}
          {props.children}
        </Styled.InternalMobileContainer>
      </MobileView>
    </>
  );
}

export default Modal;
